import numeral from "numeral";

export const DECIMAL_FORMAT = "0,0.[00]";
export const COMMAS_FORMAT = "0,0";

export const formatNumber = (num?: number | string, format: string = DECIMAL_FORMAT): string => {
  return numeral(num).format(format);
};
